var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-carousel',{attrs:{"interval":5000,"arrow":"never","height":_vm.bannerHeight + 'px',"indicator-position":"none"}},_vm._l((_vm.bannerList),function(item){return _c('el-carousel-item',{key:item},[_c('img',{ref:"bannerHeight",refInFor:true,staticClass:"swiper_banner",style:('height:'+_vm.bannerHeight+'px'),attrs:{"src":item}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2260d72a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner/index.vue
// module id = null
// module chunks = 